export const FORM_FIELDS_MAP = {
  FolderName: {
    key: 'folderName'
  },
  DestinationParentFolder: {
    key: 'destinationParentFolder'
  }
};
